import { FeatureFlagsAppConfig } from "./types";

export const shared: FeatureFlagsAppConfig = {
    local: {
        all: {},
        dica: {},
    },
    dev: {
        all: {},
        dica: {},
    },
    test: {
        all: {},
        dica: {},
    },
    accept: {
        all: {},
        dica: {},
    },
    staging: {
        all: {},
        dica: {},
    },
    demo: {
        all: {},
        dica: {},
    },
    prod: {
        all: {},
        dica: {},
    },
};
